angular.module('invoice')
    .filter('invoiceProjectBudgetAmount', function ($filter) {
        return (value, showCents, showZeros) => !showZeros && Number(value) === 0 ? '' : $filter('number')(value, showCents ? 2 : 0)
    })
    .filter('invoiceProjectBudgetPercentage', function ($filter) {
        return (value, showZeros) => !showZeros && Number(value) === 0 ? '' : $filter('percentage')(value, 1)
    })
    .factory('InvoiceProjectBudgetAnalysis', function ($resource) {
        return $resource('/crm/api/invoice-project/:projectId/budget-analysis', {}, {
            query: {method: 'GET', isArray: true},
            savePlanning: {method: 'PUT', url: '/crm/api/invoice-project/:projectId/budget-analysis/planning'}
        })
    })
